export const BRAND_VALUES = [
  {
    title: 'Tradition ohne Stillstand',
    description:
      'Wir arbeiten mit klassischen Rezepturen, verfeinern sie aber mit präzisem Timing und moderner Produktqualität.',
  },
  {
    title: 'Klare Produktlinie',
    description:
      'Weniger Beliebigkeit, mehr Fokus: jede Pizza hat ein klares Geschmacksprofil und eine nachvollziehbare Zutatenauswahl.',
  },
  {
    title: 'Service mit Struktur',
    description:
      'Abholung und Reservierungen laufen über kurze Wege. Das spart Wartezeit und schafft Vertrauen.',
  },
];

export const EXPERIENCE_STEPS = [
  {
    title: 'Teig mit Ruhe',
    description:
      'Lang geführte Teige sorgen für bessere Textur, mehr Aroma und eine leichtere Kruste.',
  },
  {
    title: 'Basis, die trägt',
    description:
      'Tomatensoße, Käse und Gewürze sind sauber abgestimmt – so schmeckt die Pizza klar, nicht überladen.',
  },
  {
    title: 'Ofen mit Charakter',
    description:
      'Der Steinofen bringt Hitze, Röstaromen und die typische Balance aus Knusper und Saftigkeit.',
  },
  {
    title: 'Finale frisch am Pass',
    description:
      'Basilikum, Rucola, Parmesan oder Chili-Öl kommen erst am Ende drauf, wenn sie wirklich wirken.',
  },
  {
    title: 'Heiß & bereit',
    description:
      'Wir takten die Abläufe so, dass du nicht lange wartest – und die Pizza heiß bei dir ankommt (Abholung/Reservierung).',
  },
];

export const TESTIMONIALS = [
  {
    quote:
      'Die Pizza kommt heiß, sauber belegt und ohne überflüssigen Schnickschnack. Genau so wirkt ein Laden, der weiß, was er tut.',
    author: 'Lena M.',
  },
  {
    quote:
      'Reservierung unkompliziert, Service aufmerksam und die Karte wirkt fokussiert statt überladen. Das macht sofort einen besseren Eindruck.',
    author: 'Jonas K.',
  },
];
